import * as yup from 'yup'

export const dataChartModalFormSchema = yup.object().shape({
  fileName: yup
    .string()
    .trim()
    .max(
      246,
      'The combination of the pack and file title is too long, maximum number of characters is 246'
    )
    .required('Title is required'),
})
